<script>
    import {fade} from 'svelte/transition';
    import user from "../../stores/user";
    import R from "../../lib/requests";
    import {setFocusTo} from "../../lib/lib";
    import Alert from "../../stores/alerts";
    import AppIcon from "../icons/AppIcon.svelte";

    let username = '';
    let password = '';
    let error = false;
    let passwordViewTitle = "view password"
    let viewPassword = false;

    const login = () => {

        const onSuccess = result => {
            user.setUser(result);
        }

        const onFailure = err => {
            error = true;
        };

        error = false;
        R.handle(R.app.login, {username, password}, onSuccess, onFailure);
    }

    const togglePasswordView = () => {
        viewPassword = !viewPassword;
        passwordViewTitle = viewPassword ? "απόκρυψη κωδικού" : "εμφάνιση κωδικού";
    }

    setFocusTo('login-username');
</script>

<div class="login-overlay" transition:fade="{{ duration: 100 }}">
    <div class="login-content">
        <div class="login-inner" class:error={ error }>
            <div class="login-logo">
                <img src="/assets/images/app-logo.svg" alt="logo">
            </div>
            <form on:submit|preventDefault|stopPropagation="{ login }">
                <div class="mb-3">
                    <input type="email" class="form-control" id="login-username" bind:value="{ username }" placeholder="email"
                           required>
                </div>
                <div class="mb-3">
                    <div class="input-group">
                        {#if viewPassword}
                            <input type="text" class="form-control" bind:value="{ password }" placeholder="κωδικός"
                                   required>
                        {:else}
                            <input type="password" class="form-control" bind:value="{ password }" placeholder="κωδικός"
                                   required>
                        {/if}
                        <span class="btn btn-default" type="button" title="{ passwordViewTitle }"
                                on:click="{ togglePasswordView }">
                            <AppIcon icon="eye" size="18"/>
                        </span>
                    </div>
                </div>
                <button class="btn btn-primary btn-block">ΕΙΣΟΔΟΣ</button>
            </form>
        </div>
    </div>
</div>

<style>
    .login-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #f2f6f8;
        z-index: 9000;
    }

    .login-content {
        position: absolute;
        width: 80%;
        max-width: 250px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }

    .login-inner {
        position: relative;
        max-width: 300px;
    }

    .login-inner.error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .login-logo {
        margin-bottom: 20px;
    }

    .login-logo img {
        width: 100%;
    }
</style>